<template>
	<div>
		<div @click="navDetail(item)" class="groupItem radius10 cursor"
		v-for="(item,i) in ptProp" :key="i">
			<div class="title_ fb line1 fsm2">{{item.title}}</div>
			<div class="flex-space color6 mt-10 mb-20 fsmain">
				已有{{item.take_part_num}}人参与拼团
				<span class="price color-main fb fsm2">￥{{item.group_buy_price}}拼团</span>
			</div>
			<div class="flex-space">
				<div class="flex-alitem">
					<img class="mr-10 radius50" width="35px" height="35px" 
					:src="item.lecturer.avatar" alt="">
					<span>{{item.lecturer.name}}</span>
				</div>
				<div>剩余<count-down :isHour="1" :endTime="item.group_end_time" :endText="''" /> 拼团结束</div>
			</div>
		</div>
	</div>
	
</template>

<script>
	import countDown from '@/components/countDown'
	export default{
		components: {
			 countDown
		},
		props:{
			isStatus:{
				type:Number,//是否显示未开始 1显示  0不显示
				defult:0//默认不显示
			},
			ptProp:{
				type:Array,
				default:()=>{return []}
			}
		},
		filters:{
			isBegin(item){
				if(item == 'not_started'){
					return '未开始'
				}
			},
			time_(time){
				let count = setInterval(()=>{
					var date = new Date();
					var now = date.getTime();  
					//设置截止时间  
					var str=time
					var endDate = new Date(str); 
					var end = endDate.getTime();  
					
					//时间差  
					var leftTime = end-now; 
					//定义变量 d,h,m,s保存倒计时的时间  
					var d,h,m,s;  
					if(leftTime >= 0){  
						d = Math.floor(leftTime/1000/60/60/24)>10 ? Math.floor(leftTime/1000/60/60/24) : '0'+Math.floor(leftTime/1000/60/60/24);  
						h = Math.floor(leftTime/1000/60/60%24)>10 ? Math.floor(leftTime/1000/60/60%24) : '0'+Math.floor(leftTime/1000/60/60%24);  
						m = Math.floor(leftTime/1000/60%60)>10 ? Math.floor(leftTime/1000/60%60) :'0'+Math.floor(leftTime/1000/60%60);  
						s = Math.floor(leftTime/1000%60);  
						return d+'天'+h+'时'+m+'分'+s+'秒'			  
					}else{
						clearInterval(count)
						return '已结束'
					} 
				},1000)
			}
		},
		data(){
			return{
				
			}
		},
		methods:{
			navDetail(item){
				if(item.live_state){
					// 直播拼团
					const {href} = this.$router.resolve({
					  path: '/details',
					  query: {
					   id:item.id,
					   propType:'ptLive'
					  }
					 })
					window.open(href, '_blank')
				}else if(item.hasOwnProperty('video_list')){
					const {href} = this.$router.resolve({
					  path: '/details',
					  query: {
					   id:item.id,
					   propType:'ptVideo'
					  }
					 })
					window.open(href, '_blank')
				}
			}
		}
	}
</script>

<style lang="less" scoped>
		.groupItem{
			width: 450px;
			background-color: #fff;
			padding: 25px 20px;
			display: inline-block;
			margin-right: 20px;
			box-shadow: 0 0 5px 1px #e5e5e5;
			&:hover{
				box-shadow: 0 0 5px 1px #cdcdcd;
			}
		}
</style>


// WEBPACK FOOTER //
// src/components/Course/ptClass.vue